(function($) {
    "use strict";

    if (!$('.hub-page-board').length) return;

    function _got_board(d) {
        $('.loading-overlay').hide();

        if (!PHI.api.handleReturn(d)) return;

        var items = d.data ? d.data.items : [],
            total = d.data ? d.data.total_found : 0,
            pages = Math.ceil(total / PHI.api.PAGE_SIZE),
            list = $('#results-list');

        list.empty();

        if (0 === total) {
            list.append('<div class="content-grid-row">No results found.</div>');

            return;
        }

        var count = 0,
            item = null,
            currentRow = null,
            art = null,
            a = null,
            img = null,
            h2 = null,
            div = null;

        for (var i = 0; i < items.length; i++) {
            item = items[i];

            if (0 === count % 3) {
                if (currentRow) list.append(currentRow);

                currentRow = $('<div class="content-grid-row hub-page-results hub-page-results-staff-row">');
            }

            art = $('<article class="hub-page-results-item">');
            art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');

            a = $('<a href="' + item.url + '">');

            img = $('<img class="expert" src="' + item.headshot_url + '">');

            h2 = $('<h2>');
            h2.text(item.title);

            div = $('<div class="hub-page-results-item__title">');
            div.text(item.job_title);

            img.prop('alt', item.title);

            a.append(img);

            art.append(a);

            a = $('<a href="' + item.url + '">');
            a.append(h2);
            art.append(a);
            art.append(div);

            currentRow.append(art);
            count++;
        }

        while (count % 3 !== 0) {
            art = $('<article class="hub-page-results-item">');
            art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');
            currentRow.append(art);
            count++;
        }

        list.append(currentRow);
    }

    $(function() {
        $('.loading-overlay').show();

        PHI.api.getBoard(0, _got_board);
    });
})(jQuery);
